import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AbstractForm } from '@usucampeao/utils-frontend';

@Component({
  selector: 'usucampeao-modal-documento-outro',
  templateUrl: './modal-documento-outro.component.html',
  styleUrls: ['./modal-documento-outro.component.scss']
})
export class ModalDocumentoOutroComponent extends AbstractForm implements OnInit {
  public form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modalCtrl: ModalController,
  ) {
    super();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      nome: [null, Validators.required],
    });
  }

  public onSubmit(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      return;
    }

    this.fecharModal(this.form.value);
  }


  public fecharModal(data?: { nome: string }): void {
    this.modalCtrl.dismiss(data);
  }

}
